import { COWTUXConfig } from '@cowtux/types';

/**
 * Default COWTUX Configuration
 *
 * You can edit these options to change the default options. All these options also can be
 * changed per component basis. See `app/main/pages/authentication/login/login.component.ts`
 * constructor method to learn more about changing these options per component basis.
 */

export const cowtuxConfig: COWTUXConfig = {
    // Color themes can be defined in src/app/app.theme.scss
    colorTheme: 'theme-orange-light',
    customScrollbars: true,
    layout: {
        style: 'vertical-layout-1',
        width: 'fullwidth',
        navbar: {
            primaryBackground: 'light-blue-900',
            secondaryBackground: 'cowtux-white-900',
            folded: false,
            hidden: false,
            position: 'left',
            variant: 'vertical-style-1'
        },
        toolbar: {
            customBackgroundColor: false,
            background: 'cowtux-white-500',
            hidden: false,
            position: 'below-fixed'
        },
        footer: {
            customBackgroundColor: true,
            background: 'cowtux-navy-900',
            hidden: false,
            position: 'below-static'
        },
        sidepanel: {
            hidden: false,
            position: 'right'
        }
    }
};
